(() => {
  if (window.__xsCrossSellV13) return;
  window.__xsCrossSellV13 = true;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const ctxOf = (el) => el.closest('cart-drawer-component') || document;

  function sync() {
    // 0) Bara de progres: CLONA sus in zona scrollabila
    document.querySelectorAll('cart-drawer-component').forEach((c) => {
      const src = c.querySelector('.cart-drawer__summary .gift-progress');
      const items = c.querySelector('.cart-drawer__items');
      if (!items) return;
      const existing = items.querySelector(':scope > .xs-bar-clone');
      if (!src) {
        if (existing) existing.remove();
        return;
      }
      const sig = src.textContent.trim().slice(0, 120);
      if (existing && existing.dataset.sig === sig) return;
      if (existing) existing.remove();
      const clone = src.cloneNode(true);
      clone.classList.add('xs-bar-clone');
      clone.dataset.sig = sig;
      items.prepend(clone);
    });

    // 0b) Economii: clona centrata sub Total
    document.querySelectorAll('cart-drawer-component, body').forEach((c) => {
      const scope = c.tagName === 'BODY' ? document : c;
      const src = scope.querySelector('.cart-savings:not(.xs-sv-clone)');
      const total = scope.querySelector('.cart-totals__total');
      if (!total) return;
      const existing = total.parentElement.querySelector('.xs-sv-clone');
      if (!src) {
        if (existing) existing.remove();
        return;
      }
      const sig = src.textContent.trim();
      if (existing && existing.dataset.sig === sig) return;
      if (existing) existing.remove();
      const clone = src.cloneNode(true);
      clone.classList.add('xs-sv-clone');
      clone.hidden = false;
      clone.dataset.sig = sig;
      total.insertAdjacentElement('afterend', clone);
    });

    // 1) Cross-sell: muta blocul din summary sub lista de produse
    document.querySelectorAll('.xs-cross-sell').forEach((block) => {
      const c = ctxOf(block);
      const scope = c === document ? document : c;
      const wrapper = [...scope.querySelectorAll('.cart-items__wrapper')].find(
        (w) => (w.closest('cart-drawer-component') || document) === c && w.querySelector('.cart-form')
      );
      if (!wrapper || block.parentElement === wrapper) return;
      wrapper.querySelectorAll('.xs-cross-sell').forEach((el) => {
        if (el !== block) el.remove();
      });
      wrapper.appendChild(block);
    });

    // 1b) Curata containerele CCU orfane
    document.querySelectorAll('.ccu-drawer-container').forEach((cont) => {
      const prev = cont.previousElementSibling;
      if (!prev || !prev.classList || !prev.classList.contains('cart-items__table-row')) {
        cont.remove();
      }
    });

    // 2) Dedupe fata de CCU + daca produsul ARE accesorii, 1 singura recomandare
    document.querySelectorAll('.xs-cross-sell').forEach((block) => {
      const c = ctxOf(block);
      const scope = c === document ? document : c;
      const shown = new Set();
      scope.querySelectorAll('[data-ccu-upsell] a[href*="/products/"]').forEach((a) => {
        const part = (a.getAttribute('href') || '').split('/products/')[1];
        if (part) shown.add(part.split('?')[0].split('#')[0]);
      });
      if (shown.size) {
        block.querySelectorAll('[data-xs-handle]').forEach((card) => {
          if (shown.has(card.dataset.xsHandle)) card.remove();
        });
      }
      const hasAccessories = !!scope.querySelector('[data-ccu-upsell] .ccu-upsell__card');
      if (hasAccessories) {
        const cards = [...block.querySelectorAll('[data-xs-handle]')];
        cards.slice(1).forEach((el) => el.remove());
      }
      if (!block.querySelector('[data-xs-handle]')) block.remove();
    });

    // 3) Sticky summary doar daca e suficient de mic
    document.querySelectorAll('cart-drawer-component').forEach((c) => {
      const dialog = c.querySelector('dialog');
      const summary = c.querySelector('.cart-drawer__summary');
      if (!dialog || !summary) return;
      const dh = dialog.getBoundingClientRect().height;
      if (!dh) return;
      const ratio = summary.getBoundingClientRect().height / dh;
      dialog.setAttribute('cart-summary-sticky', ratio > 0.55 ? 'false' : 'true');
    });
  }

  let timer;
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(sync, { timeout: 400 });
      } else {
        sync();
      }
    }, 250);
  };

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  document.addEventListener('DOMContentLoaded', schedule);
  schedule();

  // Add to cart RAPID prin sectiunea usoara xs-cart-refresh.
  // Swap TINTIT: doar continutul .cart-items__wrapper si .cart-drawer__summary
  // (cart-items-component cuprinde tot corpul drawerului — nu se atinge).
  async function addToCart(button) {
    const original = button.innerHTML;
    button.disabled = true;
    button.innerHTML = '<span class="button-text">Se adaugă...</span>';
    try {
      const response = await fetch(`${ROOT}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Add failed');

      const prevCartItems = document.querySelector('.cart-items__wrapper .cart-items');
      const prevClass = prevCartItems ? prevCartItems.className : null;
      const prevStyle = prevCartItems ? prevCartItems.getAttribute('style') : null;

      const [cart, html] = await Promise.all([
        fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()),
        fetch(`${ROOT}?section_id=xs-cart-refresh`).then((r) => r.text())
      ]);

      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const freshWrapper = tmp.querySelector('[data-xs-fresh-items] .cart-items__wrapper');
      const freshSummary = tmp.querySelector('[data-xs-fresh-summary]');

      if (freshWrapper) {
        document.querySelectorAll('.cart-items__wrapper').forEach((w) => {
          w.innerHTML = freshWrapper.innerHTML;
          if (prevClass) {
            w.querySelectorAll('.cart-items').forEach((el) => {
              el.className = prevClass;
              if (prevStyle) el.setAttribute('style', prevStyle);
            });
          }
        });
      }
      if (freshSummary) {
        document.querySelectorAll('.cart-drawer__summary').forEach((s) => {
          s.innerHTML = freshSummary.innerHTML;
        });
      }

      document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count').forEach((el) => {
        el.textContent = cart.item_count;
      });

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      schedule();
    } catch (error) {
      console.error('[XS add]', error);
      button.disabled = false;
      button.innerHTML = original;
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-xs-add], [data-ccu-add]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      addToCart(button);
    },
    true
  );
})();
